module.exports = __webpack_public_path__ + "img/chevron_big_right_white.svg";